module.exports = __webpack_public_path__ + "img/module-thumb.5b49f072.jpg";